var CommercialContextActionTypeKeys;
(function (CommercialContextActionTypeKeys) {
    CommercialContextActionTypeKeys["Get_CommercialMetadata_Success"] = "GET_MYESCALATIONS_SUCCESS";
    CommercialContextActionTypeKeys["Get_CommercialMetadata_Failure"] = "GET_MYESCALATIONS_ERROR";
    CommercialContextActionTypeKeys["Get_CommercialMetadata_InProgress"] = "GET_MYESCALATIONS_INPROGRESS";
    CommercialContextActionTypeKeys["Update_EnableAcknowledgement"] = "UPDATE_ENABLEACKNOWLEDGEMENT";
})(CommercialContextActionTypeKeys || (CommercialContextActionTypeKeys = {}));
export default CommercialContextActionTypeKeys;
